import { Skeleton } from 'ui/skeleton';
import { Container, Header, LoadingMainContent } from './styled';

export const LoadingCard = () => (
  <Container>
    <Header>
      <Skeleton height={32} />
    </Header>
    <LoadingMainContent>
      <Skeleton height={160} />
    </LoadingMainContent>
  </Container>
);
